import { AdminTemplate, MerchantTotalTransactionsReportFilter } from "../../components";

export const MerchantTotalTransactionsReport = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "İşyeri Başarılı İşlemler",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
        <MerchantTotalTransactionsReportFilter />
    </AdminTemplate>
  );
};
